import { z } from "zod";

// Resend the OTP during login (passport-web → POST /auth/mfa/challenge). `mfa_token` is the limited JWT from
// the login 202 (or the prior resend); the server re-issues a fresh OTP + a fresh rolling token.
export const mfaChallengeRequestSchema = z.object({
  mfa_token: z.string().min(1),
});
